export default "__VITE_ASSET__Dl5q9xT0__"